import __request__ from "routing/request";
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/teams", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getList(sort = "name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/teams", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getListForUsername(sort = "name", userId, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/teams/member/${userId}`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(teamId, paginationparameters, capability, entity_type, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/teams/shares/${teamId}`, paginationparameters, { "capability": capability, "entity_type": entity_type }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getByteamId(teamId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/teams/${teamId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(teamId, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.security/teams/${teamId}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(teamId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.security/teams/${teamId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getListOfUsers(sort = "username", teamId, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/teams/${teamId}/members`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addMember(teamId, userIds, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.security/teams/${teamId}/members`, userIds, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeMember(teamId, userId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.security/teams/${teamId}/members/${userId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getListOfRoles(sort = "name", teamId, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.security/teams/${teamId}/roles`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addMemberToTeams(userId, teams, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.security/teams/${userId}/teams`, teams, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
